<template>
    <Intersect
        :threshold="[0, 0]"
        @leave="pauseVideo"
        @enter="playVideo">
        <section class="section-home-hero full-width background h-screen flex flex-col">
            <!--Video Background-->
            <background-video
                :video-url="sectionHero.videoSources.videoUrl"
                :video-poster-url="sectionHero.videoSources.videoPosterUrl"
                video-id="hero-background-video"

            />

            <!--Contained section-->
            <div class="container flex flex-col justify-end flex-grow">
                <!--Stats Block Sub-layout-->
                <div class="stats-row flex flex-grow items-center pt-48">
                    <!--Layout Spacer -- Matches Aside Text Component sizing/spacing-->
                    <div class="w-1/4 max-w-xxs phone:hidden mr-10 desktop:mr-32"></div>

                    <!--Wrapper for Stats and Breakpoint conditional button -->
                    <div class="flex flex-col content-center items-start">
                        <!--Hero Stats Component-->
                        <stats-hero
                            :hero-stats-text="sectionHero.heroStatsText"
                            class="mb-20" />

                        <!--Conditional CTA button -->
                        <scroll-button
                            class="btn-gold block text-sm phone:hidden"
                            :href="scrollToHref">
                            <svg-icon
                                icon="arrow-vertical"
                                class="w-5 h-5 inline-block mr-2" />
                            {{ sectionHero.heroContent.buttonText }}
                        </scroll-button>
                    </div> <!-- Ends Wrapper-->
                </div> <!--Ends Stats Block-->

                <!--Content Layout-->
                <div class="section-content flex flex-col tablet:flex-row pb-12 hd:pb-20 imac:pb-24">
                    <!--Aside Block -- Content Text Aside Component -- Matches Layout Spacer div above for sizing/spacing-->
                    <content-text-aside
                        class="phone:hidden tablet:w-1/4 max-w-xxs mr-10 desktop:mr-32"
                        gold>
                        <template
                            v-if="sectionHero.heroContent.sideTitleText"
                            #title-text>
                            <span class="text-gold-500">{{ sectionHero.heroContent.sideTitleText }}</span>
                        </template>
                        <template
                            v-if="sectionHero.heroContent.sideSubtitleText"
                            #subtitle-text>
                            <span class="mobile:hidden font-bold text-xs text-gray-500">{{ sectionHero.heroContent
                                .sideSubtitleText }}</span>
                        </template>
                    </content-text-aside>

                    <!--Content Block Sub-layout with breakpoint conditional button -->
                    <div class="section-text-with-button">
                        <!--Content Text Component-->
                        <content-text>
                            <template
                                v-if="sectionHero.heroContent.mainTitleText"
                                #title-text>
                                <h2 class="font-bold">
                                    {{ sectionHero.heroContent.mainTitleText }}
                                </h2>
                            </template>
                            <template
                                v-if="sectionHero.heroContent.mainSubtitleText"
                                #subtitle-text>
                                <h2 class="font-light">
                                    {{ sectionHero.heroContent.mainSubtitleText }}
                                </h2>
                            </template>
                            <template
                                v-if="sectionHero.heroContent.mainContentText"
                                #content-text>
                                <p class="font-bold mb-6">
                                    {{ sectionHero.heroContent.mainContentText }}
                                </p>
                            </template>
                        </content-text>

                        <!--Conditional CTA button -->
                        <scroll-button
                            class="btn-gold block text-sm tablet:hidden"
                            :href="scrollToHref">
                            <svg-icon
                                icon="arrow-vertical"
                                class="w-5 h-5 inline-block mr-2" />
                            {{ sectionHero.heroContent.buttonText }}
                        </scroll-button>
                    </div>
                </div> <!--Ends Content Layout-->
            </div> <!--Ends Contained Section-->
        </section>
    </Intersect>
</template>

<script>
import SvgIcon from '@whisper/components/icons/SvgIcon';
import BackgroundVideo from '@web/components/BackgroundVideo';
import StatsHero from '@web/components/StatsHero';
import ContentText from '@web/components/ContentText';
import ContentTextAside from '@web/components/ContentTextAside';
import Intersect from 'vue-intersect';
import ScrollButton from '@web/components/ScrollButton';

export default {
  components: {
    BackgroundVideo,
    SvgIcon,
    StatsHero,
    ContentText,
    ContentTextAside,
    Intersect,
    ScrollButton,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
      heroStatsText: {
        type: Array,
        required: true,
      },
      heroContent: {
        type: Object,
        required: true,
      },
      videoSources: {
        type: Object,
        required: true,
      },
    },
  },
  data: () => ({
    scrollToHref: '#section-services-id-link',
  }),

  methods: {
    playVideo() {
      document.getElementById('hero-background-video').play();
    },

    pauseVideo() {
      document.getElementById('hero-background-video').pause();
    },
  },
};
</script>

<style lang="scss" scoped>
    section.section-home-hero {
        @screen mobile {
            min-height: 550px;
        }

        @screen tablet {
            min-height: 900px;
        }

        @screen tabletLandscape {
            // overrides global settings
            min-height: 900px;
        }

        @screen desktop {
            min-height: 900px;
        }

        @screen hd {
            min-height: 1080px;
        }
    }
</style>
